<div class="shell">
  @if (router.url | excludedUrls) {
    <div class="sidebar">
      <app-sidebar />
    </div>
  }
  <div class="header elz-margin--small">
    <app-header />
  </div>
  <div class="content elz-padding--small">
    <ng-content />
  </div>
</div>
